export default __webpack_public_path__ + "static/media/9.16c9610e.jpg";